"use strict";

exports.__esModule = true;

exports.default = function (ref) {
  return {
    methods: {
      focus: function focus() {
        this.$refs[ref].focus();
      }
    }
  };
};

;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/element-ui@2.15.14/node_modules/element-ui/lib/mixins/focus.js
// module id = bq6w
// module chunks = 19